import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconChevronLeft = createIcon({
  displayName: 'IconChevronLeft',
  path: [
    <path
      key="0"
      d="M15.29 21.71L5.59 12L15.29 2.29L16.71 3.71L8.41 12L16.71 20.29L15.29 21.71Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
